/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Kreditportal Backend API
 * Das Kreditportal ermöglicht Versicherungsnehmern die Kautionsverträge einzusehen, anzupassen und Bürgschaften zu beantragen. Diese API ist eine Middleware fürs Frontend zu den Backend-Systemen.
 * OpenAPI spec version: 4.0.6-FINAL
 */
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpResponse as AngularHttpResponse } from '@angular/common/http';

import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import type { ChangeProfilDataRequest, PartnerProfilData } from '../kreditportalBackendAPI.schemas';


interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};







@Injectable({ providedIn: 'root' })
export class PartnerApiService {
  private readonly http = inject(HttpClient);
/**
 * Dieser Service ermöglicht das Ändern von Nutzerprofildaten (Name, Mailadresse, ...) für einen Kunden identifiziert angand seiner Benutzer-ID.
 * @summary Profildaten für einen Nutzer ändern
 */
 changeProfilData<TData = void>(changeProfilDataRequest: ChangeProfilDataRequest, options?: HttpClientBodyOptions): Observable<TData>;
 changeProfilData<TData = void>(changeProfilDataRequest: ChangeProfilDataRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 changeProfilData<TData = void>(changeProfilDataRequest: ChangeProfilDataRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  changeProfilData<TData = void>(
    changeProfilDataRequest: ChangeProfilDataRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/partner/changeProfilData`,
      changeProfilDataRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/partner/changeProfilData`,
      changeProfilDataRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/partner/changeProfilData`,
      changeProfilDataRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Dieser Service ermöglicht das Abrufen von Nutzerprofildaten (Name, Mailadresse, ...) für einen Kunden identifiziert anhand seiner Benutzer-ID.
 * @summary Profildaten für einen Nutzer abrufen
 */
 getProfilData<TData = PartnerProfilData>(benutzerId: string, options?: HttpClientBodyOptions): Observable<TData>;
 getProfilData<TData = PartnerProfilData>(benutzerId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getProfilData<TData = PartnerProfilData>(benutzerId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getProfilData<TData = PartnerProfilData>(
    benutzerId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/partner/${benutzerId}/profilData`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/partner/${benutzerId}/profilData`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/partner/${benutzerId}/profilData`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

